import Alert from '@ixigo/icons/Alert';
import Typography from '@ixigo/iui/Typography';
import { useEffect, useState } from 'react';
import SpinnerLoader from '../Loader/Spinner';

type Props = {
    visible: boolean;
};

const BANNER_ID = 'reconnection-banner';

function ConnectionLostBanner({ visible = false }: Props) {
    const [isVisible, setIsVisible] = useState(visible);

    useEffect(() => {
        if (!isVisible) return;

        const banner = document.querySelector(`#${BANNER_ID}`) as HTMLDivElement;
        if (banner) {
            // Force reflow - reading offsetHeight forces the browser to
            // calculate current layout before we change the style
            // eslint-disable-next-line no-void
            void banner.offsetHeight;
            banner.style.top = '0px';
        }
    }, [isVisible]);

    useEffect(() => {
        if (visible) {
            setIsVisible(true);
            return;
        }

        const banner = document.querySelector(`#${BANNER_ID}`) as HTMLDivElement;
        if (banner) banner.style.top = '-100px';
    }, [visible]);

    if (!isVisible) return null;

    return (
        <div
            id={BANNER_ID}
            className='sticky -top-100 flex items-center justify-between gap-3 w-full h-auto px-20 py-10 bg-danger-600 text-white z-30 shadow flex-nowrap transition-top duration-300'
            onTransitionEnd={() => {
                if (!visible) setIsVisible(false);
            }}
        >
            <div className='flex items-center gap-3'>
                <Alert className='shrink-0 text-xl' />
                <Typography variant='body-sm'>Connection lost. Trying to reconnect...</Typography>
            </div>
            <SpinnerLoader size='xs' color='danger' />
        </div>
    );
}

export default ConnectionLostBanner;
